/*
 * cpl-countdown.js — Copaluz Christmas-cutoff countdown (sections/cpl-announcement.liquid,
 * snippets/cpl-countdown.liquid). Counts down to ONE fixed instant in `data-deadline`
 * (ISO 8601 with offset, e.g. 2026-11-20T23:59:59-06:00); it never resets on reload.
 * At the deadline: the timer is removed, the bar shows its "after" copy (class is-after), and
 * the elements matching `data-after-targets` get `data-after-targets-text` (COPY.md shipby.after).
 * No dependencies, no network calls.
 */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function switchToAfter(bar) {
    if (bar.dataset.cplAfterDone) return;
    bar.dataset.cplAfterDone = '1';
    bar.classList.add('is-after');
    var timer = bar.querySelector('[data-cpl-timer]');
    if (timer) timer.remove();
    var selector = bar.dataset.afterTargets;
    var text = bar.dataset.afterTargetsText;
    if (selector && text) {
      try {
        document.querySelectorAll(selector).forEach(function (el) {
          el.textContent = text;
        });
      } catch (e) {
        /* invalid selector in the theme setting: leave the other texts as they are */
      }
    }
  }

  function init(bar) {
    if (bar.dataset.cplCountdownReady) return;
    bar.dataset.cplCountdownReady = '1';
    var end = Date.parse(bar.dataset.deadline);
    if (isNaN(end)) return;
    var timer = bar.querySelector('[data-cpl-timer]');

    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) {
        switchToAfter(bar);
        return false;
      }
      var d = Math.floor(s / 86400);
      s %= 86400;
      if (timer) {
        timer.textContent = d + ' d ' + pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      }
      return true;
    }

    if (tick()) {
      var iv = setInterval(function () {
        if (!tick()) clearInterval(iv);
      }, 1000);
    }
  }

  function run() {
    document.querySelectorAll('[data-cpl-countdown]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* theme editor re-renders the section */
  document.addEventListener('shopify:section:load', run);
})();
